import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../SpriteMount.js";
var symbol = new SpriteSymbol({
  "id": "ridestyler-showcase-icon-house",
  "use": "ridestyler-showcase-icon-house-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"ridestyler-showcase-icon-house\"><path d=\"m88.586 52.414-4.172 4.172a2 2 0 0 1-2.828 0L50 25 18.414 56.586a2 2 0 0 1-2.828 0l-4.172-4.172a2 2 0 0 1 0-2.828l37.172-37.172a2 2 0 0 1 2.828 0l37.172 37.172a2 2 0 0 1 0 2.828zM50 29l28 28v29a2 2 0 0 1-2 2H50a2 2 0 0 1-2-2V65a1 1 0 0 0-1-1H33a1 1 0 0 0-1 1v21a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V57l28-28zm6 46a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V65a1 1 0 0 0-1-1H57a1 1 0 0 0-1 1v10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol